import { __extends, __assign, __awaiter, __generator, __makeTemplateObject } from 'tslib';
import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { createAxiosInstance } from '@next-common/redux-apollo-helper';
import globalAxios from 'axios';
import { createLogger } from '@next-common/logger';
import { configService } from '@next-common/config-service';
import { BreakpointProvider } from '@next-common/breakpoint';
import Stack from '@mui/material/Stack';
import { useGTM } from '@next-common/gtm-provider';
import Slider from 'react-slick';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import BaseBadge from '@mui/material/Badge';
import { colorPalette } from '@next-common/mui';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Typography from '@mui/material/Typography';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

var ACTIONS;
(function (ACTIONS) {
    ACTIONS["FETCH_PRODUCT_IMAGE_DATA_SUCCESS"] = "productImage/FETCH_PRODUCT_IMAGE_DATA_SUCCESS";
    ACTIONS["FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_SUCCESS"] = "productImage/FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_SUCCESS";
    ACTIONS["FETCH_USER_DATA_SUCCESS"] = "productImage/FETCH_USER_DATA_SUCCESS";
    ACTIONS["FETCH_PRODUCT_IMAGE_DATA_ERROR"] = "productImage/FETCH_PRODUCT_IMAGE_DATA_ERROR";
    ACTIONS["FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_ERROR"] = "productImage/FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_ERROR";
    ACTIONS["FETCH_USER_DATA_ERROR"] = "productImage/FETCH_USER_DATA_ERROR";
    ACTIONS["FETCH_IS_PRODUCT_FAVORITE_REQUEST"] = "productImage/FETCH_PRODUCT_IMAGE_DATA_REQUEST";
    ACTIONS["FETCH_IS_PRODUCT_FAVORITE_SUCCESS"] = "productImage/FETCH_IS_PRODUCT_FAVORITE_SUCCESS";
    ACTIONS["FETCH_IS_PRODUCT_FAVORITE_ERROR"] = "productImage/FETCH_IS_PRODUCT_FAVORITE_ERROR";
    ACTIONS["PRODUCT_FAVORITE_UPDATE_REQUEST"] = "productImage/PRODUCT_FAVORITE_UPDATE_REQUEST";
    ACTIONS["PRODUCT_FAVORITE_UPDATE_SUCCESS"] = "productImage/PRODUCT_FAVORITE_UPDATE_SUCCESS";
    ACTIONS["PRODUCT_FAVORITE_UPDATE_ERROR"] = "productImage/PRODUCT_FAVORITE_UPDATE_ERROR";
})(ACTIONS || (ACTIONS = {}));
var ACTIONS$1 = ACTIONS;

/* tslint:disable */
var BASE_PATH = "http://localhost:36200".replace(/\/+$/, "");
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, axios) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (axios === void 0) { axios = globalAxios; }
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = "RequiredError";
        return _this;
    }
    return RequiredError;
}(Error));

/* tslint:disable */
/**
 *
 * @export
 */
var DUMMY_BASE_URL = 'https://example.com';
/**
 *
 * @throws {RequiredError}
 * @export
 */
var assertParamExists = function (functionName, paramName, paramValue) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, "Required parameter ".concat(paramName, " was null or undefined when calling ").concat(functionName, "."));
    }
};
function setFlattenedQueryParams(urlSearchParams, parameter, key) {
    if (key === void 0) { key = ""; }
    if (typeof parameter === "object") {
        if (Array.isArray(parameter)) {
            parameter.forEach(function (item) { return setFlattenedQueryParams(urlSearchParams, item, key); });
        }
        else {
            Object.keys(parameter).forEach(function (currentKey) {
                return setFlattenedQueryParams(urlSearchParams, parameter[currentKey], "".concat(key).concat(key !== '' ? '.' : '').concat(currentKey));
            });
        }
    }
    else {
        if (urlSearchParams.has(key)) {
            urlSearchParams.append(key, parameter);
        }
        else {
            urlSearchParams.set(key, parameter);
        }
    }
}
/**
 *
 * @export
 */
var setSearchParams = function (url) {
    var objects = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objects[_i - 1] = arguments[_i];
    }
    var searchParams = new URLSearchParams(url.search);
    setFlattenedQueryParams(searchParams, objects);
    url.search = searchParams.toString();
};
/**
 *
 * @export
 */
var toPathString = function (url) {
    return url.pathname + url.search + url.hash;
};
/**
 *
 * @export
 */
var createRequestFunction = function (axiosArgs, globalAxios, BASE_PATH, configuration) {
    return function (axios, basePath) {
        if (axios === void 0) { axios = globalAxios; }
        if (basePath === void 0) { basePath = BASE_PATH; }
        var axiosRequestArgs = __assign(__assign({}, axiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + axiosArgs.url });
        return axios.request(axiosRequestArgs);
    };
};

/* tslint:disable */
/**
 * DataForProductImageApi - axios parameter creator
 * @export
 */
var DataForProductImageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get data for Product Image
         * @param {string} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImageData: function (productId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    assertParamExists('getProductImageData', 'productId', productId);
                    localVarPath = "/restpublic/web/vis/product/hypernova/{productId}/images"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * DataForProductImageApi - functional programming interface
 * @export
 */
var DataForProductImageApiFp = function (configuration) {
    var localVarAxiosParamCreator = DataForProductImageApiAxiosParamCreator(configuration);
    return {
        /**
         * Get data for Product Image
         * @param {string} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImageData: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductImageData(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DataForProductImageApi - object-oriented interface
 * @export
 * @class DataForProductImageApi
 * @extends {BaseAPI}
 */
var DataForProductImageApi = /** @class */ (function (_super) {
    __extends(DataForProductImageApi, _super);
    function DataForProductImageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get data for Product Image
     * @param {string} productId product ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataForProductImageApi
     */
    DataForProductImageApi.prototype.getProductImageData = function (productId, options) {
        var _this = this;
        return DataForProductImageApiFp(this.configuration).getProductImageData(productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataForProductImageApi;
}(BaseAPI));
/**
 * DataForProductMemoAndPriceAlertInformationApi - axios parameter creator
 * @export
 */
var DataForProductMemoAndPriceAlertInformationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get data for Product Memo and price alert information
         * @param {string} productId product ID
         * @param {number} userId user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMemoData: function (productId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    assertParamExists('getProductMemoData', 'productId', productId);
                    // verify required parameter 'userId' is not null or undefined
                    assertParamExists('getProductMemoData', 'userId', userId);
                    localVarPath = "/restpublic/web/vis/product/hypernova/{productId}/memo/{userId}"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)))
                        .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * DataForProductMemoAndPriceAlertInformationApi - functional programming interface
 * @export
 */
var DataForProductMemoAndPriceAlertInformationApiFp = function (configuration) {
    var localVarAxiosParamCreator = DataForProductMemoAndPriceAlertInformationApiAxiosParamCreator(configuration);
    return {
        /**
         * Get data for Product Memo and price alert information
         * @param {string} productId product ID
         * @param {number} userId user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMemoData: function (productId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductMemoData(productId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DataForProductMemoAndPriceAlertInformationApi - object-oriented interface
 * @export
 * @class DataForProductMemoAndPriceAlertInformationApi
 * @extends {BaseAPI}
 */
var DataForProductMemoAndPriceAlertInformationApi = /** @class */ (function (_super) {
    __extends(DataForProductMemoAndPriceAlertInformationApi, _super);
    function DataForProductMemoAndPriceAlertInformationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get data for Product Memo and price alert information
     * @param {string} productId product ID
     * @param {number} userId user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataForProductMemoAndPriceAlertInformationApi
     */
    DataForProductMemoAndPriceAlertInformationApi.prototype.getProductMemoData = function (productId, userId, options) {
        var _this = this;
        return DataForProductMemoAndPriceAlertInformationApiFp(this.configuration).getProductMemoData(productId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataForProductMemoAndPriceAlertInformationApi;
}(BaseAPI));
/**
 * DataForProductRepairabilityIndexApi - axios parameter creator
 * @export
 */
var DataForProductRepairabilityIndexApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get Product Repairability Index
         * @param {number} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairabilityIndexData: function (productId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    assertParamExists('getRepairabilityIndexData', 'productId', productId);
                    localVarPath = "/restprivate/products/{productId}/repairability"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * DataForProductRepairabilityIndexApi - functional programming interface
 * @export
 */
var DataForProductRepairabilityIndexApiFp = function (configuration) {
    var localVarAxiosParamCreator = DataForProductRepairabilityIndexApiAxiosParamCreator(configuration);
    return {
        /**
         * Get Product Repairability Index
         * @param {number} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairabilityIndexData: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRepairabilityIndexData(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DataForProductRepairabilityIndexApi - object-oriented interface
 * @export
 * @class DataForProductRepairabilityIndexApi
 * @extends {BaseAPI}
 */
var DataForProductRepairabilityIndexApi = /** @class */ (function (_super) {
    __extends(DataForProductRepairabilityIndexApi, _super);
    function DataForProductRepairabilityIndexApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get Product Repairability Index
     * @param {number} productId product ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataForProductRepairabilityIndexApi
     */
    DataForProductRepairabilityIndexApi.prototype.getRepairabilityIndexData = function (productId, options) {
        var _this = this;
        return DataForProductRepairabilityIndexApiFp(this.configuration).getRepairabilityIndexData(productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataForProductRepairabilityIndexApi;
}(BaseAPI));
/**
 * UpdateProductMemoApi - axios parameter creator
 * @export
 */
var UpdateProductMemoApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Update a memo with the specified product ID
         * @param {number} xAjaxrequest
         * @param {string} [action]
         * @param {string} [productId]
         * @param {string} [skipkmadding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productMemoUpdate: function (xAjaxrequest, action, productId, skipkmadding, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xAjaxrequest' is not null or undefined
                    assertParamExists('productMemoUpdate', 'xAjaxrequest', xAjaxrequest);
                    localVarPath = "/memo";
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (xAjaxrequest != null) {
                        localVarHeaderParameter['x-ajaxrequest'] = typeof xAjaxrequest === 'string'
                            ? xAjaxrequest
                            : JSON.stringify(xAjaxrequest);
                    }
                    if (action !== undefined) {
                        localVarFormParams.set('action', action);
                    }
                    if (productId !== undefined) {
                        localVarFormParams.set('productId', productId);
                    }
                    if (skipkmadding !== undefined) {
                        localVarFormParams.set('skipkmadding', skipkmadding);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * UpdateProductMemoApi - functional programming interface
 * @export
 */
var UpdateProductMemoApiFp = function (configuration) {
    var localVarAxiosParamCreator = UpdateProductMemoApiAxiosParamCreator(configuration);
    return {
        /**
         * Update a memo with the specified product ID
         * @param {number} xAjaxrequest
         * @param {string} [action]
         * @param {string} [productId]
         * @param {string} [skipkmadding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productMemoUpdate: function (xAjaxrequest, action, productId, skipkmadding, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productMemoUpdate(xAjaxrequest, action, productId, skipkmadding, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * UpdateProductMemoApi - object-oriented interface
 * @export
 * @class UpdateProductMemoApi
 * @extends {BaseAPI}
 */
var UpdateProductMemoApi = /** @class */ (function (_super) {
    __extends(UpdateProductMemoApi, _super);
    function UpdateProductMemoApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update a memo with the specified product ID
     * @param {number} xAjaxrequest
     * @param {string} [action]
     * @param {string} [productId]
     * @param {string} [skipkmadding]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateProductMemoApi
     */
    UpdateProductMemoApi.prototype.productMemoUpdate = function (xAjaxrequest, action, productId, skipkmadding, options) {
        var _this = this;
        return UpdateProductMemoApiFp(this.configuration).productMemoUpdate(xAjaxrequest, action, productId, skipkmadding, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UpdateProductMemoApi;
}(BaseAPI));

var logger = createLogger('product-image');
var loadProductImagesData = function (axiosInstance, productId, basePath) {
    return function (dispatch) {
        var dataForProductImageApi = new DataForProductImageApi(undefined, basePath, axiosInstance);
        return dataForProductImageApi
            .getProductImageData(productId)
            .then(function (result) {
            var data = result.data;
            // @ts-expect-error productId
            data.productId = productId;
            dispatch({
                type: ACTIONS$1.FETCH_PRODUCT_IMAGE_DATA_SUCCESS,
                payload: data,
            });
        })
            .catch(function (err) {
            if (err instanceof Error) {
                logger.error("".concat(err.name, ": ").concat(err.message), { exception: err.stack });
            }
            else {
                logger.error('An error occurred while loading product images', { exception: err });
            }
            throw (err.response ? { status: err.response.status, statusText: err.response.statusText } : err);
        });
    };
};
var loadRepairabilityIndexData = function (axiosInstance, productId, repairabilityIndexBaseUrl, repairabilityIndexSvgLocationBaseUrl) {
    return function (dispatch) {
        var intProductId = Number(productId);
        var dataForProductRepairabilityIndexApi = new DataForProductRepairabilityIndexApi(undefined, repairabilityIndexBaseUrl, axiosInstance);
        return dataForProductRepairabilityIndexApi
            .getRepairabilityIndexData(intProductId)
            .then(function (result) {
            var data = result.data;
            var repairabilityIndexPdfUrl = data.document;
            var repairabilityIndexImageUrl;
            if (data.index !== undefined && data.index !== null) {
                var wholePart = Math.floor(data.index);
                var decimalPart = Math.floor((data.index * 10) % 10);
                repairabilityIndexImageUrl = "".concat(repairabilityIndexSvgLocationBaseUrl).concat(wholePart, "_").concat(decimalPart, ".svg");
            }
            var details = {
                repairabilityIndexImageUrl: repairabilityIndexImageUrl,
                repairabilityIndexPdfUrl: repairabilityIndexPdfUrl
            };
            dispatch({
                type: ACTIONS$1.FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_SUCCESS,
                payload: details,
            });
        })
            .catch(function (err) {
            if (err instanceof Error) {
                logger.debug("".concat(err.name, ": ").concat(err.message), { exception: err.stack });
            }
            else {
                logger.debug('An error occurred while loading repairability index', { exception: err });
            }
        });
    };
};

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadProductImagesData: loadProductImagesData,
  loadRepairabilityIndexData: loadRepairabilityIndexData
});

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var initialAction = function (watchContext, baseUrl, preloadedConfig) {
    return function (dispatch) {
        var promises = [];
        var axiosInstance = createAxiosInstance({ context: watchContext, moduleName: 'ProductImageModule' });
        var _a = preloadedConfig.ProductImage, productId = _a.productId, wsBaseUrl = _a.wsBaseUrl; _a.userId;
        // load Data when called on nextJs Eshop Landing Desktop & mob + and on pricemobile or monolithe
        promises.push(dispatch(loadProductImagesData(axiosInstance, productId, wsBaseUrl)));
        var axiosRepairabilityIndex = createAxiosInstance({ context: watchContext, moduleName: 'ProductImageRepairabilityIndexModule', log404AsDebug: true });
        var config = configService.get();
        promises.push(dispatch(loadRepairabilityIndexData(axiosRepairabilityIndex, preloadedConfig.ProductImage.productId, config.repairabilityIndex.repairabilityIndexPdfUrl, config.repairabilityIndex.repairabilityIndexSvgLocationPrefix)));
        return Promise.all(promises);
    };
};

var previewStyles = {
    miniPreviewWrapper: function (selected) { return ({
        border: "1px solid ".concat(selected ? 'black' : colorPalette.gray300),
        cursor: 'pointer',
        width: '48px',
        height: '48px',
        borderRadius: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            boxShadow: "0px 0px 0px 4px ".concat(colorPalette.gray100),
        },
    }); },
    miniPreview: {
        width: '32px',
        height: '32px',
        objectFit: 'contain',
    },
    seeMoreWrapper: {
        position: 'relative',
        display: 'flex',
        height: '48px',
        width: '48px',
        cursor: 'pointer',
        justifyContent: 'center',
        alignItems: 'center',
        border: "1px solid ".concat(colorPalette.gray300),
        borderRadius: '8px',
        '&:hover': {
            boxShadow: "0px 0px 0px 4px ".concat(colorPalette.gray100),
        },
    },
    seeMoreContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        borderRadius: '6px',
        opacity: 0.5,
        backgroundColor: 'white',
    }
};
styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme, previewLength = _a.previewLength;
    return (_b = {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            borderRadius: '6px',
            backgroundColor: 'white'
        },
        _b[theme.breakpoints.up('lg')] = {
            opacity: previewLength - 1 === 0 ? 0 : 0.5,
        },
        _b);
});
styled(BaseBadge)(function (_a) {
    var _b;
    var theme = _a.theme, previewLength = _a.previewLength;
    return (_b = {
            display: previewLength - 1 === 0 ? 'none' : 'flex',
            color: 'white',
            fontSize: '12px',
            fontWeight: 600,
            position: 'relative',
            '&::before': {
                content: "\"+".concat(previewLength - 1, "\""),
                position: 'absolute',
                zIndex: 999,
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '100%',
                backgroundColor: 'black',
                padding: '2px 4px',
            }
        },
        _b[theme.breakpoints.down('lg')] = {
            display: previewLength !== 0 ? 'flex' : 'none',
            '&::before': {
                content: "\"+".concat(previewLength, "\""),
                position: 'absolute',
                zIndex: 999,
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '100%',
                backgroundColor: 'black',
                padding: '2px 4px',
            },
        },
        _b);
});
var MiniPreviewList = styled(Stack)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.down('lg')] = {
            '&& :nth-child(5)': {
                display: 'none',
            },
        },
        _b[theme.breakpoints.down('md')] = {
            display: 'none',
        },
        _b);
});

var PREVIEW_LENGTH = 3;
var Preview = function (_a) {
    var images = _a.images, productId = _a.productId, onImageClick = _a.onImageClick, onVideoClick = _a.onVideoClick, _b = _a.video, video = _b === void 0 ? false : _b, hoveredImageIndex = _a.hoveredImageIndex, setHoveredImageIndex = _a.setHoveredImageIndex;
    var openGalleryHtml = function (image) {
        var match = image === null || image === void 0 ? void 0 : image.match(/\d{10}/);
        var imageId = match ? match[0] : '';
        return ("\n      <a class=\"prdPhoto\" style=\"display: block; height: 100%; width: 100%; align-content: center; text-align: center;\" onclick=\"PM.AdvertList.displayDiapoWithCallbackOnShow(PM.BT.ub(47,'image',63,'action',61,'slideshow',38,'iac',61,'true',38,'imagestype',61,'PRODUCT',38,'prdimageid',61,'".concat(imageId, "',38,'productid',61,'").concat(productId, "'), ()=>{}); return false;\">\n        <img src=\"").concat(image, "?frz-width=48&frz-height=40&frz-fit=contain\" style=\"max-height: 76%; height: 50px\" alt=\"small\" class=\"photo\" pagespeed_no_defer>\n      </a>\n    "));
    };
    var showMoreGalleryHtml = function () {
        return ("\n        <a class=\"prdPhoto\" style=\"display: block; height: 100%; width: 100%; align-content: center; text-align: center;\" onclick=\"PM.AdvertList.displayDiapo(PM.BT.ub(47,'image',63,'action',61,'slideshow',38,'iac',61,'true',38,'imagestype',61,'PRODUCT',38,'prdimageid',61,'".concat(images[3], "',38,'productid',61,'").concat(productId, "'), ()=>{}); return false;\">\n          <img src=\"").concat(images[3], "?frz-width=48&frz-height=40&frz-fit=contain\" style=\"max-height: 76%; height: 50px\" alt=\"small\" class=\"photo\" pagespeed_no_defer>\n        </a>\n      "));
    };
    var showImageBadge = function () { return ("\n        <div class=\"V5Stack-root css-1qaxv1h\" style=\"display:".concat(images.length - 3 > 1 ? 'flex' : 'none', "\">\n          <a onclick=\"PM.AdvertList.displayDiapo(PM.BT.ub(47,'image',63,'action',61,'slideshow',38,'iac',61,'true',38,'imagestype',61,'PRODUCT',38,'prdimageid',61,'").concat(images[3], "',38,'productid',61,'").concat(productId, "'), ()=>{}); return false;\">\n            <span style=\"z-index: 999;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            background-color: black;\n            border-radius: 100%;\n            position: absolute;\n            padding: 2px 4px;\n            text-align: center\">\n              <span style=\"font-size: 12px; font-weight: 600; color: white; display: flex; flex-direction: row; flex-wrap: wrap; line-height: 1\">+").concat(images.length - 4, "</span>\n            </span>\n          </a>\n        </div>\n      ")); };
    return (React.createElement(MiniPreviewList, { spacing: 1, "data-qa": "image-mini-preview-list", sx: {
            marginRight: '8px',
        } },
        images.slice(0, 3).map(function (src, i) { return (React.createElement(Stack, { component: "div", key: i, sx: previewStyles.miniPreviewWrapper(i === hoveredImageIndex), onClick: function () { return onImageClick(src); }, onMouseEnter: function () {
                setHoveredImageIndex(i);
            } },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: openGalleryHtml(src) } }))); }),
        images.length > PREVIEW_LENGTH && (React.createElement(Box, { component: "div", sx: previewStyles.seeMoreWrapper },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: showImageBadge() } }),
            React.createElement("div", { style: { position: 'relative', opacity: '50%' }, dangerouslySetInnerHTML: { __html: showMoreGalleryHtml() } }))),
        video && (React.createElement(Box, { "data-qa": "test-video", component: "div", sx: previewStyles.seeMoreWrapper },
            React.createElement(Stack, { component: "div", sx: previewStyles.miniPreview, alignItems: 'center', justifyContent: 'center', onClick: onVideoClick },
                React.createElement(PlayArrowIcon, { sx: {
                        fontSize: '20px',
                    } }),
                React.createElement(Typography, { fontWeight: 600, fontSize: "12px" }, "Vid\u00E9o"))))));
};

var favoriteStyles = {
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: "1px solid ".concat(colorPalette.gray300),
        backgroundColor: 'white',
        cursor: 'pointer',
        borderRadius: 100,
        width: 40,
        height: 40,
    }
};

var Favorite = function (_a) {
    var isFavorite = _a.isFavorite, onFavoriteClick = _a.onFavoriteClick;
    return (React.createElement(Box, { "data-qa": 'Favorite-test', className: "frznocache", sx: favoriteStyles.buttonWrapper, onClick: onFavoriteClick }, isFavorite ? (React.createElement(FavoriteIcon, { sx: { fontSize: 24, color: colorPalette.red800 } })) : (React.createElement(FavoriteBorderIcon, { sx: { fontSize: 24, color: colorPalette.gray700 } }))));
};

var notificationStyles = {
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: "1px solid ".concat(colorPalette.gray300),
        backgroundColor: 'white',
        cursor: 'pointer',
        borderRadius: 100,
        width: 40,
        height: 40,
    }
};

var Notification = function (_a) {
    var isNotificationOn = _a.isNotificationOn, _b = _a.dataQa, dataQa = _b === void 0 ? 'notification-comp' : _b, onNotificationClick = _a.onNotificationClick;
    return (React.createElement(Box, { "data-qa": dataQa, className: "frznocache", sx: notificationStyles.buttonWrapper, onClick: onNotificationClick }, isNotificationOn ? (React.createElement(NotificationAddIcon, { sx: { fontSize: 24, color: colorPalette.red800 } })) : (React.createElement(NotificationAddOutlinedIcon, { sx: { fontSize: 24, color: colorPalette.gray700 } }))));
};

var repairabilityIndexStyles = {
    indexWrapper: {
        width: 65,
        height: 40,
    }
};

var RepairabilityIndex = function (_a) {
    var imageUrl = _a.imageUrl, pdfUrl = _a.pdfUrl;
    if (!pdfUrl) {
        if (!imageUrl) {
            return null;
        }
        else {
            return (React.createElement(Box, { "data-da": 'repairability-test', component: "a", target: "_blank", sx: repairabilityIndexStyles.indexWrapper },
                React.createElement("img", { src: imageUrl, width: "65", height: "40", alt: "Repairability Index" })));
        }
    }
    else {
        return (React.createElement(Box, { "data-qa": 'repairability-test', component: "a", href: pdfUrl, target: "_blank", sx: repairabilityIndexStyles.indexWrapper },
            React.createElement("img", { src: imageUrl, width: "65", height: "40", alt: "Repairability Index" })));
    }
};

var ImageGallery = function (_a) {
    var urlsImage = _a.urlsImage, hoveredImageIndex = _a.hoveredImageIndex;
    return ("\n  <section class=\"productZoom photosZoom photos_gallery\" style=\"position: fixed; top: 0; left: 0; width: 100%; background-color: white; z-index: 1000\">\n    <div class=\"zoomControl\">\n      <div class=\"backToFP\">\n        <a rel=\"nofollow\" href=\"javascript:;\" id=\"back-button\" style=\"margin-bottom: 5px\" class=\"next btn-input-like ui-btn ui-btn-up-c ui-shadow ui-btn-corner-all ui-btn-icon-left\" data-role=\"button\" data-icon=\"arrow-l-white\" data-iconpos=\"left\" data-corners=\"true\" data-shadow=\"true\" data-iconshadow=\"true\" data-wrapperels=\"span\" data-theme=\"c\"><span class=\"ui-btn-inner\"><span class=\"ui-btn-text\">Retour</span><span class=\"ui-icon ui-icon-arrow-l-white ui-icon-shadow\">&nbsp;</span></span></a>\n      </div>\n\n      <div class=\"slider\">\n          <a rel=\"nofollow\" href=\"javascript:;\" id=\"prev-button\" class=\"previous btn-input-like ui-link\">\n              <svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.5 21.75L17.5605 20.6895L8.871 12L17.5605 3.3105L16.5 2.25L6.75 12L16.5 21.75Z\" fill=\"#333333\"></path>\n              </svg>\n          </a>\n          <span class=\"current\" style=\"font-size: 14px;\">".concat(hoveredImageIndex + 1, "/").concat(urlsImage.length, "</span>\n          <a rel=\"nofollow\" href=\"javascript:;\" id=\"next-button\" class=\"next btn-input-like ui-link\">\n              <svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.8105 2.25L6.75 3.3105L15.4395 12L6.75 20.6895L7.8105 21.75L17.5605 12L7.8105 2.25Z\" fill=\"#333333\"></path>\n              </svg>\n          </a>\n      </div>\n    </div>\n\n    ").concat(urlsImage.map(function (image, index) {
        return ("\n        <div class=\"figure\" style=\"display: ".concat(hoveredImageIndex === index ? 'block' : 'none', ";\">\n          <div class=\"sxy-zoom-container sxy-zoom-mode-window\" style=\"max-width: 500px; width: 100%; height: auto; position: relative;\">\n            <a class=\"sxyzoom swinxywindow ui-link\" href=\"").concat(image, "?frz-width=532&frz-fit=contain\" style=\"cursor: default; display: none;\">\n              <img class=\"photo\" alt=\"LEGO Icons - Le jardin paisible - 10315\" src=\"").concat(image, "?frz-width=532&frz-fit=contain\" style=\"width: 250px;\">\n            </a>\n              <img class=\"sxy-zoom-bg\" src=\"").concat(image, "?frz-width=532&frz-fit=contain\" style=\"object-fit: contain;\">\n              <div style=\"padding-top: 100%;\"></div>\n              <div class=\"sxy-controls\" style=\"display: none;\">\n                <div class=\"overlay\"></div>\n                <a class=\"in\" href=\"#\"></a>\n                <div class=\"sxy-slider\">\n                  <div class=\"sxy-handle\" style=\"top: 0px;\"></div>\n                </div>\n                <a class=\"out\" href=\"#\"></a>\n              </div>\n            <div class=\"sxy-zoom-dragpad\">\n              <div class=\"sxy-overlay\"></div>\n              <div class=\"sxy-zoom-viewport\" style=\"opacity: 0;\">\n                <img galleryimg=\"no\">\n              </div>\n              <img class=\"inner-thumb\" src=\"").concat(image, "?frz-width=532&frz-fit=contain\" style=\"opacity: 0; object-fit: contain;\">\n              <div class=\"sxy-zoom-viewfinder\" style=\"display: none;\"></div>\n            </div>\n            <div class=\"sxy-loading\"><span></span></div>\n          </div>\n        </div>\n      "));
    }).join(''), "\n\n\n  <div class=\"dfpAds\">\n      <!-- /57948771/Priceminister_FR_MSITE/rg/fp_di_pave Cas A-->\n      <div id=\"div-gpt-ad-1586159123536-0\" class=\"gptAd\">\n      </div>\n  </div>\n</section>\n  "));
};

var _a;
({
    imageBox: (_a = {
            objectFit: 'contain',
            cursor: 'pointer'
        },
        _a['@media only screen and (min-width: 1441px) and (max-width: 1920px)'] = {
            width: '532px',
            height: '532px',
        },
        _a['@media only screen and (min-width: 1201px) and (max-width: 1440px)'] = {
            width: '472px',
            height: '472px',
        },
        _a['@media (max-width: 1200px)'] = {
            width: '270px',
            height: '270px',
        },
        _a),
});
var MobileImageBox = styled(Stack)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.up('md')] = {
            display: 'none',
        },
        _b.width = '375px',
        _b.height = '280px',
        _b['.slick-dots'] = (_c = {},
            _c[theme.breakpoints.up('md')] = {
                display: 'none',
            },
            _c['li.slick-active button:before'] = {
                color: colorPalette.red800,
                fontSize: '6px',
            },
            _c.li = {
                width: '6px',
                height: '20px',
            },
            _c),
        _b['.slick-slide'] = {
            img: (_d = {
                    objectFit: 'contain',
                    width: '100%',
                    height: '280px'
                },
                _d[theme.breakpoints.up('md')] = {
                    display: 'none',
                },
                _d),
        },
        _b);
});
var ImageBoxWrapper = styled(Stack)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.down('md')] = {
            display: 'none',
        },
        _b);
});
var ImageIconsWrapper = styled(Stack)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.down('md')] = {
            display: 'none',
        },
        _b);
});
var ImageContainer = styled(Stack)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            marginBottom: '30px',
            maxHeight: '531px',
            justifyContent: 'space-between'
        },
        _b[theme.breakpoints.down('md')] = {
            marginTop: '30px',
        },
        _b);
});
var GalleryWrapper = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#fff',
            "zIndex": 1000
        },
        _b[theme.breakpoints.up('md')] = {
            display: 'none',
        },
        _b);
});
var ImageContainerDim = styled('div')(function (_a) {
    var _b;
    _a.theme;
    return (_b = {
            width: '365px',
            height: '400px'
        },
        _b['@media (max-width: 1580px)'] = {
            width: '360px',
            height: '400px',
        },
        _b['@media (max-width: 1562px)'] = {
            width: '350px',
            height: '400px',
        },
        _b['@media (max-width: 1536px)'] = {
            width: '340px',
            height: '375px',
        },
        _b['@media (max-width: 1500px)'] = {
            width: '330px',
            height: '375px',
        },
        _b['@media (max-width: 1473px)'] = {
            width: '320px',
            height: '375px',
        },
        _b['@media (max-width: 1440px)'] = {
            width: '310px',
            height: '335px',
        },
        _b['@media (max-width: 1410px)'] = {
            width: '300px',
            height: '335px',
        },
        _b['@media (max-width: 1380px)'] = {
            width: '290px',
            height: '300px',
        },
        _b['@media (max-width: 1350px)'] = {
            width: '276px',
            height: '300px',
        },
        _b['@media (max-width: 1315px)'] = {
            width: '250px',
            height: '300px',
        },
        _b['@media (max-width: 1250px)'] = {
            width: '230px',
            height: '275px',
        },
        _b['@media (max-width: 1175px)'] = {
            width: '216px',
            height: '250px',
        },
        _b['@media (max-width: 1130px)'] = {
            width: '200px',
            height: '216px',
        },
        _b['@media (max-width: 1076px)'] = {
            width: '190px',
            height: '216px',
        },
        _b);
});
var ImageDimMob = styled(Box)(function (_a) {
    var _b;
    _a.theme;
    return (_b = {
            maxWidth: '335px'
        },
        _b['@media (max-width: 424px)'] = {
            width: '315px !important',
        },
        _b['@media (max-width: 412px)'] = {
            width: '300px !important',
        },
        _b['@media (max-width: 400px)'] = {
            width: '276px !important',
        },
        _b['@media (max-width: 387px)'] = {
            width: '250px !important',
            paddingRight: '30px',
        },
        _b['@media (max-width: 360px)'] = {
            width: '200px !important',
            paddingRight: '30px',
        },
        _b['@media (max-width: 350px)'] = {
            width: '200px !important',
            paddingRight: '50px',
        },
        _b['@media (max-width: 340px)'] = {
            width: '200px !important',
            paddingRight: '80px',
        },
        _b);
});

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var getFavoriteState = function (productId, userId) { return function (dispatch) {
    dispatch({ type: ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_REQUEST });
    if (!userId)
        return;
    var gatewayUrl = '';
    var dataForProductMemoApi = new DataForProductMemoAndPriceAlertInformationApi(undefined, gatewayUrl);
    dataForProductMemoApi.getProductMemoData(productId, userId).then(function (result) {
        var data = result.data;
        dispatch({
            type: ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_SUCCESS,
            payload: data,
        });
    })
        .catch(function (err) {
        dispatch({
            type: ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_ERROR,
            payload: err.response && err.response.data,
        });
    });
}; };
var handleMemoClick = function (isFavorite, url) { return function (dispatch) {
    dispatch({ type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_REQUEST });
    var res = url.split("?");
    var body = res[1] + "&skipkmadding=" + !isFavorite;
    var params = {};
    body.split('&').forEach(function (param) {
        var _a = param.split('='), key = _a[0], value = _a[1];
        params[key] = value;
    });
    new UpdateProductMemoApi(undefined, '').productMemoUpdate(1, params['action'], params['productId'], params['skipkmadding']).then(function (result) {
        var _a, _b;
        var data = result.data;
        switch (data.code) {
            case 1:
                if ((_a = data === null || data === void 0 ? void 0 : data.values) === null || _a === void 0 ? void 0 : _a.loginURL)
                    window.location.href = ((_b = data === null || data === void 0 ? void 0 : data.values) === null || _b === void 0 ? void 0 : _b.loginURL) + "&ajx_param=memo&ajx_value=submit";
                break;
            case 2:
                dispatch({
                    type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_SUCCESS,
                    payload: true,
                });
                break;
            case 3:
                dispatch({
                    type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_SUCCESS,
                    payload: false,
                });
                break;
            default:
                dispatch({
                    type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_ERROR,
                    payload: false,
                });
                break;
        }
    }).catch(function (err) {
        dispatch({
            type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_ERROR,
            payload: err.response && err.response.data,
        });
    });
}; };

var Image = function (_a) {
    var urlsImage = _a.urlsImage, productId = _a.productId, _b = _a.dataQa, dataQa = _b === void 0 ? 'images-core' : _b, draggable = _a.draggable, hasRichContentVideo = _a.hasRichContentVideo; _a.jsonContext; var blurredMemoUpdateActionUrl = _a.blurredMemoUpdateActionUrl; _a.productAlertTagClick; var urlProductAlert = _a.urlProductAlert, onNotificationClick = _a.onNotificationClick, repairabilityIndexImageUrl = _a.repairabilityIndexImageUrl, repairabilityIndexPdfUrl = _a.repairabilityIndexPdfUrl;
    var dispatch = useDispatch();
    var sendEvent = useGTM().sendEvent;
    var _c = useState(0), hoveredImageIndex = _c[0], setHoveredImageIndex = _c[1];
    var _d = useState(false), isGalleryOpen = _d[0], setIsGalleryOpen = _d[1];
    var _e = useState(true), loading = _e[0], setLoading = _e[1];
    var _f = useState(0), mobileGalleryIndex = _f[0], setMobileGalleryIndex = _f[1];
    var userData = useSelector(function (state) { return state.productImage && state.productImage.userData; });
    var productAdditionalData = useSelector(function (state) { return state.productImage && state.productImage.productAdditionalData; });
    var settings = {
        arrows: false,
        dots: true,
        beforeChange: function (oldIndex, newIndex) {
            setHoveredImageIndex(newIndex);
            setMobileGalleryIndex(newIndex);
        },
    };
    var onVideoClick = function () {
        var targetSection = document.getElementById('ancre_rich_ctn');
        if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth' });
        }
    };
    useEffect(function () {
        var _a;
        dispatch(getFavoriteState(productId, (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.userId));
    }, [userData]);
    var onFavoriteClick = function () {
        dispatch(handleMemoClick(productAdditionalData === null || productAdditionalData === void 0 ? void 0 : productAdditionalData.isFavorite, blurredMemoUpdateActionUrl));
    };
    var openGalleryHtml = function () {
        var _a;
        var match = (_a = urlsImage[hoveredImageIndex]) === null || _a === void 0 ? void 0 : _a.match(/\d{10}/);
        var imageId = match ? match[0] : '';
        return ("\n      <a class=\"prdMainPhoto\" style=\" display: block; height: 100%; text-align: center\" onclick=\"PM.AdvertList.displayDiapoWithCallbackOnShow(PM.BT.ub(47,'image',63,'action',61,'slideshow',38,'iac',61,'true',38,'imagestype',61,'PRODUCT',38,'prdimageid',61,'".concat(imageId, "',38,'productid',61,'").concat(productId, "'), ()=>{}); return false;\">\n        <img src=\"").concat(urlsImage && urlsImage[hoveredImageIndex], "?frz-width=532&frz-fit=contain\" alt=\"Main\" class=\"photo\" style=\"height: -webkit-fill-available; object-fit: contain; object-position: top;\" />\n      </a>\n    "));
    };
    var handleBackPress = useCallback(function () {
        setHoveredImageIndex(mobileGalleryIndex);
        setIsGalleryOpen(false);
    }, [mobileGalleryIndex]);
    var handlePrevPress = useCallback(function () {
        if (hoveredImageIndex === 0) {
            setHoveredImageIndex(urlsImage.length - 1);
        }
        else {
            setHoveredImageIndex(function (prev) { return prev - 1; });
        }
        sendEvent({
            event: 'FPA::diaporama_produit_defilement',
            page_title: 'product image',
            location_alias: 'product_image_prev',
        });
    }, [hoveredImageIndex, urlsImage.length]);
    var handleNextPress = useCallback(function () {
        if (hoveredImageIndex === urlsImage.length - 1) {
            setHoveredImageIndex(0);
        }
        else {
            setHoveredImageIndex(function (prev) { return prev + 1; });
        }
        sendEvent({
            event: 'FPA::diaporama_produit_defilement',
            page_title: 'product image',
            location_alias: 'product_image_next',
        });
    }, [hoveredImageIndex, urlsImage.length]);
    useEffect(function () {
        var backAnchor = document.getElementById('back-button');
        if (backAnchor) {
            backAnchor.addEventListener('click', handleBackPress);
        }
        var prevAnchor = document.getElementById('prev-button');
        if (prevAnchor) {
            prevAnchor.addEventListener('click', handlePrevPress);
        }
        var nextAnchor = document.getElementById('next-button');
        if (nextAnchor) {
            nextAnchor.addEventListener('click', handleNextPress);
        }
        return function () {
            if (backAnchor) {
                backAnchor.removeEventListener('click', handleBackPress);
            }
            if (prevAnchor) {
                prevAnchor.removeEventListener('click', handlePrevPress);
            }
            if (nextAnchor) {
                nextAnchor.removeEventListener('click', handleNextPress);
            }
        };
    }, [handleBackPress, handlePrevPress, handleNextPress, isGalleryOpen]);
    var handleOpenGalleryMobile = function () {
        setIsGalleryOpen(function (prev) { return !prev; });
        sendEvent({
            event: 'FPA::diaporama_produit_ouverture',
            page_title: 'product image',
            location_alias: 'product_image_open',
        });
    };
    return (React.createElement(Stack, { "data-qa": dataQa },
        React.createElement(ImageContainer, { direction: "row", position: "relative" },
            React.createElement(Preview, { images: urlsImage || [], onVideoClick: onVideoClick, video: hasRichContentVideo, hoveredImageIndex: hoveredImageIndex, setHoveredImageIndex: setHoveredImageIndex, productId: productId }),
            React.createElement(ImageBoxWrapper, { direction: "row", position: "relative" },
                React.createElement(HtmlContent, { loading: loading, setLoading: setLoading, htmlContent: openGalleryHtml() })),
            !loading && React.createElement(ImageIconsWrapper, { spacing: 1 },
                React.createElement(Favorite, { isFavorite: productAdditionalData === null || productAdditionalData === void 0 ? void 0 : productAdditionalData.isFavorite, onFavoriteClick: onFavoriteClick }),
                React.createElement("a", { href: urlProductAlert },
                    React.createElement(Notification, { isNotificationOn: productAdditionalData === null || productAdditionalData === void 0 ? void 0 : productAdditionalData.hasPriceAlert, onNotificationClick: onNotificationClick })),
                React.createElement(RepairabilityIndex, { imageUrl: repairabilityIndexImageUrl, pdfUrl: repairabilityIndexPdfUrl })),
            React.createElement(MobileImageBox, null,
                React.createElement(Slider, __assign({ draggable: draggable, lazyLoad: 'ondemand' }, settings), urlsImage === null || urlsImage === void 0 ? void 0 : urlsImage.map(function (src, i) {
                    return (React.createElement(Fragment, { key: i },
                        React.createElement(ImageDimMob, { component: "img", loading: i !== 0 ? 'lazy' : 'eager', onClick: handleOpenGalleryMobile, alt: "sliderImage", src: "".concat(src, "?frz-width=261&frz-fit=contain") })));
                })),
                isGalleryOpen && React.createElement(GalleryWrapper, { dangerouslySetInnerHTML: { __html: ImageGallery({ urlsImage: urlsImage, hoveredImageIndex: hoveredImageIndex }) } }),
                React.createElement(Stack, { spacing: 1, sx: {
                        position: 'absolute',
                        top: 0,
                        right: 0,
                    } },
                    React.createElement(Favorite, { isFavorite: productAdditionalData === null || productAdditionalData === void 0 ? void 0 : productAdditionalData.isFavorite, onFavoriteClick: onFavoriteClick }),
                    React.createElement(RepairabilityIndex, { imageUrl: repairabilityIndexImageUrl, pdfUrl: repairabilityIndexPdfUrl }))))));
};
var HtmlContent = function (_a) {
    var htmlContent = _a.htmlContent, loading = _a.loading, setLoading = _a.setLoading;
    var _b = useState(''), content = _b[0], setContent = _b[1];
    useEffect(function () {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        var img = tempDiv.querySelector('img');
        if (img) {
            img.onload = function () {
                setLoading(false);
                setContent(htmlContent);
            };
            // eslint-disable-next-line no-self-assign
            img.src = img.src;
        }
        else {
            setLoading(false);
            setContent(htmlContent);
        }
    }, [htmlContent]);
    return (React.createElement("div", null, loading ? (React.createElement("div", { style: { width: 350, height: 500 } })) : (React.createElement(ImageContainerDim, { dangerouslySetInnerHTML: { __html: content } }))));
};

var GET_USERID_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query productImage {\n  profile {\n    userId\n  }\n}\n"], ["query productImage {\n  profile {\n    userId\n  }\n}\n"])));
var templateObject_1;

var mapStateToProps = function (state) {
    var productImage = state.productImage;
    return __assign({}, productImage);
};
var mapDispatchToProps = function (dispatch) { return ({
    initialAction: function (context, baseUrl, preloadedConfig) { return dispatch(initialAction(context, baseUrl, preloadedConfig)); }
}); };
var ConnectedProductImage = connect(mapStateToProps, mapDispatchToProps)(Image);
var BreakpointWrappedProductImage = function () {
    var dispatch = useDispatch();
    var initialQuery = useQuery(GET_USERID_QUERY);
    if (initialQuery && !initialQuery.loading) {
        dispatch({ type: ACTIONS$1.FETCH_USER_DATA_SUCCESS, payload: initialQuery.data });
    }
    return (React.createElement(BreakpointProvider, null,
        React.createElement(ConnectedProductImage, null)));
};
var ProductImageContainer = BreakpointWrappedProductImage;

var NAME = 'productImage';
var DEFAULT_STATE = {};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NAME: NAME,
  DEFAULT_STATE: DEFAULT_STATE
});

var initialState = {
    productId: '',
    userId: '',
    urlsImage: [],
    hasRichContentVideo: false,
    isFavorite: false,
    userData: null
};
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ACTIONS$1.FETCH_PRODUCT_IMAGE_DATA_SUCCESS:
            return __assign(__assign({}, state), action.payload);
        case ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_REQUEST:
            return __assign(__assign({}, state), { productAdditionalData: null });
        case ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_SUCCESS:
            return __assign(__assign({}, state), { productAdditionalData: action.payload });
        case ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_ERROR:
            return __assign(__assign({}, state), { productAdditionalData: null });
        case ACTIONS$1.PRODUCT_FAVORITE_UPDATE_REQUEST:
            return __assign({}, state);
        case ACTIONS$1.PRODUCT_FAVORITE_UPDATE_SUCCESS:
            return __assign(__assign({}, state), { productAdditionalData: __assign(__assign({}, state.productAdditionalData), { isFavorite: action.payload }) });
        case ACTIONS$1.PRODUCT_FAVORITE_UPDATE_ERROR:
            return __assign({}, state);
        case ACTIONS$1.FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_SUCCESS:
            return __assign(__assign({}, state), { repairabilityIndexImageUrl: action.payload.repairabilityIndexImageUrl, repairabilityIndexPdfUrl: action.payload.repairabilityIndexPdfUrl });
        case ACTIONS$1.FETCH_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { userData: action.payload });
        default:
            return state;
    }
}

var containers = { ProductImageContainer: ProductImageContainer };
var productImageModule = { containers: containers, actions: actions, constants: constants, reducer: reducer, initalAction: initialAction };

export { productImageModule as default };
